import { ExtendedTypography, FontSizes } from '@cseo/styles';
import { mergeStyles } from '@fluentui/react';
export var getStyles = function (props) {
    var theme = props.theme;
    return {
        itemDismissUndo: {
            padding: '12px 32px 12px 32px'
        },
        attentionText: [
            mergeStyles(ExtendedTypography.size14Semibold),
            {
                paddingTop: '4px',
                lineHeight: '24px'
            }
        ],
        readMoreText: [
            mergeStyles(ExtendedTypography.size14Semibold),
            {
                paddingTop: '4px',
                marginRight: '20px',
                lineHeight: '24px'
            }
        ],
        subjectTextRead: [
            mergeStyles(ExtendedTypography.size14Semibold),
            {
                whiteSpace: 'normal',
                marginTop: '0px',
                marginBottom: '0px'
            }
        ],
        subjectTextUnread: [
            mergeStyles(ExtendedTypography.size14Bold),
            {
                whiteSpace: 'nowrap',
                marginTop: '0px',
                marginBottom: '0px'
            }
        ],
        senderNameRead: [mergeStyles(ExtendedTypography.size14Regular)],
        senderNameUnread: [mergeStyles(ExtendedTypography.size14Semibold)],
        timeDeliveredRead: [mergeStyles(ExtendedTypography.size12Regular)],
        timeDeliveredUnread: [mergeStyles(ExtendedTypography.size12Semibold)],
        root: {
            position: 'relative',
            selectors: {
                '&:hover .contextButton, &:focus-within .contextButton': {
                    opacity: 1
                },
                '&:hover .timeHook, &:focus-within .timeHook': {
                    opacity: 0
                }
            }
        },
        rootButtonDiv: {
            alignSelf: 'stretch',
            border: '0px',
            height: 'auto',
            padding: '12px 32px 12px 12px',
            textAlign: 'left',
            selectors: {
                ':hover, :focus': {
                    backgroundColor: theme.palette.neutralLighter
                },
                ':active': {
                    backgroundColor: theme.palette.neutralLight
                },
                ':focus': {
                    outlineColor: theme.palette.neutralSecondary
                }
            }
        },
        messageBody: {
            overflow: 'hidden',
            wordWrap: 'break-word'
        },
        leftColumn: {
            width: '20px'
        },
        unreadIcon: {
            color: theme.palette.themePrimary,
            fontSize: '8px',
            marginTop: '6px'
        },
        timestampRow: {
            flexGrow: 1,
            justifyContent: 'space-between',
            position: 'relative'
        },
        senderImage: {
            marginTop: '4px',
            maxWidth: '40px'
        },
        subjectContainer: {
            flex: 1
        },
        icon: {
            alignSelf: 'flex-top',
            fontSize: FontSizes.size16,
            margin: '0px 6px 0px 0px',
            paddingTop: '3px'
        },
        timeHook: [
            'timeHook',
            {
                opacity: 1
            }
        ],
        contextMenuContainer: {
            position: 'absolute',
            right: '32px',
            top: '3px'
        },
        contextButton: [
            'contextButton',
            {
                opacity: 0
            }
        ],
        additionalContent: {
            marginLeft: '20px'
        }
    };
};
//# sourceMappingURL=CoherenceNotificationItem.styles.js.map